import { ARTICLE_FEATURED_TYPES } from '../../constants'

export const getVideoFeaturedTypes = () => [].concat(ARTICLE_FEATURED_TYPES.COMMON).concat(ARTICLE_FEATURED_TYPES.IMAGE)
